/* global axios */
import ApiClient from './ApiClient';

class BroadcastsAPI extends ApiClient {
  constructor() {
    super('broadcasts', { accountScoped: true });
  }

  get({ page = 1 } = {}) {
    return axios.get(this.url, {
      params: { page },
    });
  }

  create(data = {}) {
    return axios.post(this.url, { broadcast: data });
  }

  update(id, data = {}) {
    return axios.patch(`${this.url}/${id}`, { broadcast: data });
  }

  audiencePreview(audience = {}) {
    // Явная JSON-строка: axios всё равно приводит вложенный объект query-params
    // к строке, а бэкенд детерминированно парсит её сам.
    return axios.get(`${this.url}/audience_preview`, {
      params: { audience: JSON.stringify(audience) },
    });
  }

  // Р11 п.10: ИИ дорабатывает черновой текст в сообщение для рассылки.
  generateContent(prompt) {
    return axios.post(`${this.url}/generate_content`, { prompt });
  }

  sendNow(id) {
    return axios.post(`${this.url}/${id}/send_now`);
  }

  recipients(id, { page = 1 } = {}) {
    return axios.get(`${this.url}/${id}/recipients`, {
      params: { page },
    });
  }

  stats(id) {
    return axios.get(`${this.url}/${id}/stats`);
  }
}

export default new BroadcastsAPI();
